import {
  getMessageMediaApiUrl,
  getMessageMediaApiUrlMiddleware,
} from "../../../config/config";
export const BILLING_CYCLE_DAY_URL = `${getMessageMediaApiUrlMiddleware()}/billing/v2/bill-cycle-day`;
export const REPORTING_MONTHLY_USAGE = `${getMessageMediaApiUrl()}/v2-preview/reporting/messages/insights`;
export const PLATFORM_INTEGRATIONS = `${getMessageMediaApiUrl()}/int-bff/integrations/platforms/list/1?limit=30`;
